import { withProps } from 'recompose';
import {
  FontSizeTool,
  maxFontSize,
  minFontSize,
} from '@nextiva/rich-text-editor';
import EditableDropdownTextEditorTool from '../EditableDropdownTextEditorTool';

import styles from './FontSizeTextEditorTool.scss';

export default withProps({
  minValue: minFontSize,
  maxValue: maxFontSize,
  component: EditableDropdownTextEditorTool,
  className: styles.tool,
  tooltip: 'Font Size',
})(FontSizeTool);
